import {Backdrop, Stack} from "@mui/material";
import Loader from "@memaro/components/Loader.tsx";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";

const LoadingScreen = () => {
    const [showLoader, setShowLoader] = useState<boolean>(false)
    useEffect(() => {
        const timeout = setTimeout(() => setShowLoader(true), 200)
        return () => clearTimeout(timeout)
    }, [])
    return (
        <Backdrop open={true} sx={{zIndex: (theme) => theme.zIndex.drawer + 1, background: (theme) => theme.palette.background.paper}}>
            {showLoader ? (
                <Stack flexDirection="column" alignItems="center" justifyContent="center" height="100%" width="100%" >
                    <Loader size={200} />
                    <Typography fontSize={30}>Memaro wordt geladen...</Typography>
                </Stack>
            ) : null}
        </Backdrop>
    )
}

export default LoadingScreen
